module.exports = __webpack_public_path__ + "img/ic-line@.b101abfd.svg";